import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
import Checkbox from "canvas-core-react/lib/Checkbox";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

import useApi from "../../hooks/useApi";
import Modal from "../../utils/customModal";
import {
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../utils/functions";
import { getRoles } from "../../../Redux/reducer/session";
import { useTranslation } from "react-i18next";
import { EXECUTE, MOD_RELATIONS } from "../../../permissions";
import { useHistory, useParams } from "react-router";
import MainTemplate from "../mainTemplate";
import AccountTypeSelect, {LABELS_ACCOUNT_TYPE} from "../../shared/AccountTypeSelect";
import RadioOptionSelector from "../../shared/custom-components/RadioOptionSelector";

export const format = ({ totalLines, totalLinesOk, details }) => {
  if (totalLines === totalLinesOk)
    return <p>La operación fue realizada con éxito.</p>;

  return (
    <>
      <p>Se presentaron los siguientes errores:</p>
      <ul>
        {details.map(({ message }, key) => (
          <li key={`res-${key}`}>{message}</li>
        ))}
      </ul>
    </>
  );
};

const RelationTemporal = () => {
  const { t } = useTranslation();
  const { getApiCAll, cancellCall, putApiCAll } = useApi();
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [globalApproval, setGlobalApproval] = useState(`${t("no")}`);
  const roles = useSelector((state) => getRoles(state));
  const history = useHistory();
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const [radioSelectorProps, setRadioSelectorProps] = useState({
    containerClassName: "",
    titleClassName: "",
    title: t("providers.relation_temporal.title"),
    input1: {
      id: t("yes"),
      value: t("yes"),
      label: t("yes"),
      disabled: false,
    },
    input2: {
      id: t("no"),
      value: t("no"),
      label: t("no"),
      disabled: false,
    },
  });

  useEffect(() => {
    getApiCAll(`/providers/additions-modifications-accouts/${id}`).then(
      (response) => {
        const enabledRadioButtons = !response.data.data.firstUser;
        const radioProps = {
          ...radioSelectorProps,
          input1: {
            ...radioSelectorProps.input1,
            disabled: enabledRadioButtons,
          },
          input2: {
            ...radioSelectorProps.input2,
            disabled: enabledRadioButtons,
          },
        };

        const selected = response.data.data.global ? t("yes") : t("no");
        setGlobalApproval(selected);
        setRadioSelectorProps({ ...radioProps });
        setData(response.data.data);
        setLoading(false);
      }
    );

    return () => cancellCall();
  }, []);

  const getProfile = () => {
    return data.accountId !== null ? modifyAccount() : newAccount();
  };

  const newAccount = () => {
    return (
      <>
        <Column lg={6}>
          <AccountTypeSelect
            id="accountType"
            name="accountType"
            className="default-selector"
            disabled={true}
            value={data.accountType}
          />
        </Column>
        <Column lg={6}>
          <TextField
            id="accountNumber"
            label="Número de Cuenta"
            value={data.accountNumber || "No aplica"}
            disabled={true}
          />
        </Column>
        <Column lg={6}>
          <TextField
            id="accountCurrency"
            label="Moneda"
            value={
              (data.currency && t(`general.currency.${data.currency}`)) ||
              "No aplica"
            }
            disabled={true}
          />
        </Column>
        <Column lg={6}>
          <TextField
            id="bicDestinationBank"
            label="Bic Banco Destino"
            value={data.bicDestinationBank || "No aplica"}
            disabled={true}
          />
        </Column>
        <Column lg={6}>
          <TextField
            id="bicIntermediaryBank"
            label="Bic Banco Intermediario"
            value={data.bicIntermediaryBank || "No aplica"}
            disabled={true}
          />
        </Column>
        <Column lg={6}>
          <TextField
            id="accountIntermediaryBank"
            label="Cuenta Banco Destino con Intermediario"
            value={data.bicAccountIntermediaryBank || "No aplica"}
            disabled={true}
          />
        </Column>
      </>
    );
  };

  const modifyAccount = () => {
    return (
      <>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                id="accountTypeCurrent"
                label="Tipo de Cuenta Actual"
                name="accountTypeCurrent"
                disabled={true}
                value={data.oldAccountType === 'BNS' ? LABELS_ACCOUNT_TYPE?.BNS : data.oldAccountType === 'LOCAL' ? LABELS_ACCOUNT_TYPE?.LOCAL : data.oldAccountType === 'INT' ? LABELS_ACCOUNT_TYPE?.INT : "" || "No aplica"}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountType"
                label="Tipo de Cuenta Nueva"
                name="accountType"
                disabled={true}
                value={data.accountType === 'BNS' ? LABELS_ACCOUNT_TYPE?.BNS : data.accountType === 'LOCAL' ? LABELS_ACCOUNT_TYPE?.LOCAL : data.accountType === 'INT' ? LABELS_ACCOUNT_TYPE?.INT : ""  || "No aplica"}

              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumberCurrent"
                name="accountNumberCurrent"
                label="Número de Cuenta Actual"
                value={data.oldAccountNumber || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumber"
                label="Número de Cuenta Nueva"
                name="accountNumber"
                value={data.accountNumber || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBankCurrent"
                name="accountIntermediaryBankCurrent"
                label={"Cuenta Banco Destino\ncon Intermediario Actual"}
                value={data.olBicAccountIntermediaryBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBank"
                name="accountIntermediaryBank"
                label={"Cuenta Banco Destino\ncon Intermediario Nueva"}
                value={data.bicAccountIntermediaryBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={12}>
              <Checkbox
                id="modifyAllBill"
                label="Actualizar esta cuenta para todas las relaciones"
                name="modifyAllBill"
                checked={data.modifyAllRelationship || false}
                disabled={true}
              />
            </Column>
          </Row>
        </Column>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                id="bicDestinationBankCurrent"
                name="bicDestinationBankCurrent"
                label="Bic Banco Destino Actual"
                value={data.oldBicDestinationBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicDestinationBank"
                name="bicDestinationBank"
                label="Bic Banco Destino Nueva"
                value={data.bicDestinationBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBankCurrent"
                name="bicIntermediaryBankCurrent"
                label="Bic Banco Intermediario Actual"
                value={data.olBicIntermediaryBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBank"
                name="bicIntermediaryBank"
                label="Bic Banco Intermediario Nueva"
                value={data.bicIntermediaryBank || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountCurrencyCurrent"
                name="accountCurrencyCurrent"
                label="Moneda"
                value={t(`general.currency.${data.oldCurrency}`)}
                disabled={true}
                className="currency-style"
              />
            </Column>
            <Column lg={12}>
              <Checkbox
                id="modifyAllRelationship"
                label="Actualizar esta cuenta en todas las facturas en transito"
                name="modifyAllRelationship"
                checked={data.modifyAllBill || false}
                disabled={true}
              />
            </Column>
          </Row>
        </Column>
      </>
    );
  };

  const doApproveOrReject = (data) => {
    setLoading(true);
    return putApiCAll(
      `/providers/additions-modifications-accouts-pro/approve-or-rejected`,
      data,
      {}
    )
      .then((response) => {
        setLoading(false);
        getModalResponse(response.data);
      })
      .catch(() => {
        setLoading(false);
        let button = {
          formBtn: {
            text: "Cerrar",
            action: () => {
              setModal({
                show: false,
                ontent: null,
                onClose: undefined,
              });
            },
          },
        };
        let content = sucessInfoModal(
          "Adiciones/Modificaciones",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          button
        );
        setModal({
          show: true,
          content,
          onClose: () => history.replace("/providerSite/relations"),
        });
      });
  };

  const getModalResponse = (response) => {
    let button = { formBtn: { text: "Continuar", action: closeAndReset } };
    let content = sucessInfoModal(
      "Adiciones/Modificaciones",
      format(response.data),
      button
    );
    setModal({ show: true, content, onClose: closeAndReset });
  };

  const closeAndReset = () => {
    closeModal();
    goBack();
    setModal({
      show: false,
      ontent: null,
      onClose: undefined,
    });
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const makeApproveOrReject = (approve) => {
    const global = globalApproval === t("yes") ? true : false;
    doApproveOrReject([{ approve, id, global }]);
  };

  const goBack = () => {
    history.push("/providerSite/relations");
  };

  const handleGlobalApproval = (event) => {
    setGlobalApproval(event.target.value);
  };

  return !loading ? (
    <>
      <MainTemplate className="">
        <div className="profile">
          <h3>Perfil de la relación / Detalle de la relación activa</h3>
          <Grid fluid={true}>
            <Row>
              <Column lg={6}>
                <TextField
                  id="companyName"
                  label="Nombre de la empresa relacionada"
                  value={data.companyName}
                  disabled={true}
                />
              </Column>
              <Column lg={6}>
                <TextField
                  id="companyId"
                  label="Identificación"
                  value={data.businessId}
                  disabled={true}
                />
              </Column>
            </Row>
          </Grid>

          <Grid fluid={true}>
            <Row>
              <Column lg={6} className="request-type-and-stutus-provider">
                <TextField
                  id="companyName"
                  label="Tipo de Solicitud"
                  value={t(
                    `general.relationTypes_detail_2.${data.requestType}`
                  )}
                  disabled={true}
                />
              </Column>
              <Column lg={6} className="request-type-and-stutus-provider">
                <TextField
                  id="companyId"
                  label="Estado de la Solicitud"
                  value={t(`general.inviteStates.${data.invitationStatus}`)}
                  disabled={true}
                />
              </Column>
            </Row>
          </Grid>
          <h3>Datos de la cuenta de liquidación</h3>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              {getProfile()}
            </Row>
          </Grid>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              <Row nested>
                <Column lg={6}>
                  <RadioOptionSelector
                    selected={globalApproval}
                    handleChange={handleGlobalApproval}
                    radioSelectorProps={radioSelectorProps}
                  />
                </Column>
              </Row>
            </Row>
          </Grid>
        </div>
        <div className="form-actions clearfix">
          <SecondaryButton onClick={() => goBack()}>Atrás</SecondaryButton>
          {moduleAction(roles, MOD_RELATIONS, EXECUTE) && (
            <>
              <SecondaryButton onClick={() => makeApproveOrReject(false)}>
                Rechazar
              </SecondaryButton>
              <SecondaryButton onClick={() => makeApproveOrReject(true)}>
                Aprobar
              </SecondaryButton>
            </>
          )}
        </div>
      </MainTemplate>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  ) : (
    <Modal show={true}>{loadingHtml()}</Modal>
  );
};

export default RelationTemporal;
